import React from "react";
import useStyles from "./useStyles";

const SectionBorder = ({ radius = "4" }: { radius?: string }) => {
  const { borderRoot } = useStyles();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      className={borderRoot}
    >
      <rect
        width="100%"
        height="100%"
        fill="none"
        rx={radius}
        ry={radius}
        stroke="#1976D2"
        strokeWidth="1"
        x="0"
        y="0"
        strokeDashoffset="-5"
        strokeLinecap="square"
        vectorEffect="non-scaling-stroke"
        strokeDasharray="10, 10"
      />
    </svg>
  );
};

export default SectionBorder;
